import Action from '@/views/ConductInspection/Items/Action.vue';
import Page from './Page.vue';
import Section from './Section.vue';
import ConditionalSection from './ConditionalSection.vue';
import Question from './Question.vue';
import UnknownItem from './UnknownItem.vue';

export default {
    functional: true,
    render(h, { props }) {
        let item;
        switch (props.item.type) {
            case 'page':
                item = Page;
                break;
            case 'section':
                item = Section;
                break;
            case 'conditional_section':
                item = ConditionalSection;
                break;
            case 'question':
                item = Question;
                break;
            case 'action':
                item = Action;
                break;
            default:
                item = UnknownItem;
        }

        return h(item, {
            class: props.item.type,
            props,
        });
    },
};
